
import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { Category } from '../types/Category';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

interface SpiderChartProps {
    data: Record<Category, number>;
}

const SpiderChart: React.FC<SpiderChartProps> = ({ data }) => {
    const categories: Category[] = ['Health', 'Finance', 'Education', 'Social', 'Ideology', 'Feelings'];

    const chartData = {
        labels: categories,
        datasets: [
            {
                label: 'Category Values',
                data: categories.map((category) => data[category]),
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 2,
                pointBackgroundColor: 'rgba(54, 162, 235, 1)',
                pointBorderColor: '#fff',
            },
        ],
    };

    const maxVal = Math.max(...categories.map((category) => data[category]))
    const chartOptions = {
        scales: {
            r: {
                beginAtZero: true,
                max: maxVal,
                ticks: {
                    stepSize: Math.ceil(maxVal / 5),
                    display: true,
                    color: '#ffffff',
                },
                grid: {
                    color: 'rgba(255, 255, 255, 0.2)',
                },
                angleLines: {
                    color: 'rgba(255, 255, 255, 0.2)',
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
    };

    return (
        <div style={{ maxWidth: '400px', margin: '0 auto', backgroundColor: '#1c1c1c', padding: '20px', borderRadius: '10px' }}>
            <Radar data={chartData} options={chartOptions} />
        </div>
    );
};

export default SpiderChart;
